import React from 'react';
import cn from 'classnames';
import { IBaseElementProps } from 'tbk-components/src/components/BasicElement';
import Button, { ILink } from 'tbk-components/src/components/Button';
import Image, { IImage } from 'tbk-components/src/components/Image';
import Carousel, { CarouselItem } from 'tbk-components/src/components/Carousel';

export interface ICarouselItem {
	heading: string;
	secondaryText: string;
	image?: IImage;
	link?: string;
}

export interface ISoMuchMoreThanAStoreProps extends IBaseElementProps {
	children?: any;
	heading?: string;
	/**
	 * @control textarea
	 */
	leadInText?: string;
	featuredLink?: ILink;
	carouselItems?: ICarouselItem[];
}

/**
 * So Much More Than A Store
 * @block
 * @requiresHooks
 * @icon align-right
 */
const SoMuchMoreThanAStore: React.FC<ISoMuchMoreThanAStoreProps> = ({
	children,
	className,
	classNames = [],
	heading,
	leadInText,
	featuredLink,
	carouselItems,
}) => {
	return (
		<div className={className || cn('much-more-component', ...classNames)}>
			<div className="container-fluid">
				<div className="row">
					<div className="col-12 col-lg-5 much-more-component__left">
						<div className="much-more-component__left-content">
							{heading && <h2>{heading}</h2>}
							{leadInText && (
								<p className="subheading">{leadInText}</p>
							)}
							{featuredLink && (
								<Button
									className="btn btn-lg btn-primary"
									{...featuredLink}
								/>
							)}
						</div>
					</div>
					<div className="d-none d-lg-block col-lg-7 much-more-component__right">
						{carouselItems.length > 0 && (
							<Carousel
								perView={4}
								showBullets={false}
								options={{
									gap: 23,
									peek: {
										before: 0,
										after: 0,
									},
								}}
								id="carousel-component-desktop"
							>
								{carouselItems.map((carouselItem, index) => (
									<CarouselItem key={index}>
										<a
											href={carouselItem.link}
											className="much-more-component__carousel-item"
											key={index}
										>
											<Image
												className="img-fluid"
												{...carouselItem.image}
											/>
											<div className="much-more-component__carousel-item-overlay">
												<h4>{carouselItem.heading}</h4>
												<div className="much-more-component__carousel-item-overlay-hover">
													<p className="hover-heading">
														{carouselItem.heading}
													</p>
													<p className="hover-secondary-text">
														{
															carouselItem.secondaryText
														}
													</p>
												</div>
											</div>
										</a>
									</CarouselItem>
								))}
							</Carousel>
						)}
					</div>
					<div className="col-12 d-lg-none much-more-component_mobile-carousel">
						{carouselItems.length > 0 && (
							<Carousel
								perView={3}
								showArrows={true}
								showBullets={false}
								options={{
									type: 'carousel',
									gap: 16,
									breakpoints: {
										768: {
											perView: 2,
											peek: {
												before: 0,
												after: 0,
											},
										},
										575: {
											perView: 1,
											peek: {
												before: 0,
												after: 56,
											},
										},
									},
								}}
								id="carousel-component-mobile"
							>
								{carouselItems.map((carouselItem, index) => (
									<CarouselItem key={index}>
										<a
											href={carouselItem.link}
											className="much-more-component__mobile-carousel-item"
											key={index}
										>
											<Image
												className="img-fluid"
												{...carouselItem.image}
											/>
											<div className="much-more-component__mobile-carousel-item-overlay">
												<h4>{carouselItem.heading}</h4>
												<p>
													{carouselItem.secondaryText}
												</p>
											</div>
										</a>
									</CarouselItem>
								))}
							</Carousel>
						)}
					</div>
				</div>
			</div>
		</div>
	);
};

export default SoMuchMoreThanAStore;
